module.exports = __webpack_public_path__ + "static/media/3Thumbnail.e973fbaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3Thumbnail.jpg
// module id = 1466
// module chunks = 33